// @file Custom Tldraw ErrorFallback component
import { useTldrawError } from '@@/vuecomposables/useTldrawError'
import { useEffect } from 'react'

const ErrorFallback = ({ error }): React.JSX.Element => {
  useEffect(() => {
    useTldrawError().captureError(error)
  }, [error])

  // We don't want to render the default error boundary because it shows tldraw specific copy
  // and it also has a "reset data" button which could be destructive.
  return <></>
}

export default ErrorFallback
